const base_url = process.env.REACT_APP_API_BASE;

const requestOptionsGET = {
  method: "GET",
  headers: {
    "Content-Type": "application/json",
  },
};

export const checkNewData = async (index: number) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      index: index,
    }),
  };

  const response = await fetch(`${base_url}/getEncodedState`, requestOptions);

  const data = await response.json();
  const hashName =
    index === 1 ? "roadmapHash" : index === 2 ? "aboutHash" : "homeHash";
  try {
    const hash = JSON.parse(localStorage.getItem(hashName) || "");
    if (hash === data["data"].uuid) {
      return true;
    }
    localStorage.setItem(hashName, JSON.stringify(data["data"].uuid));
    return false;
  } catch {
    localStorage.setItem(hashName, JSON.stringify(data["data"].uuid));
    return false;
  }
};

export const getRoadmap = async () => {
  let localData = localStorage.getItem("roadmapData");
  if (localData !== null && (await checkNewData(1))) {
    return;
  }

  const response = await fetch(`${base_url}/getRoadmap`, requestOptionsGET);

  const data = await response.json();

  localStorage.setItem("roadmapData", JSON.stringify(data["data"]));
};

export const sendFeedback = async (
  recommendation: number,
  usefulness: number,
  feedback_msg: string,
  title: string
) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      recommendation: recommendation,
      usefulness: usefulness,
      feedback_msg: feedback_msg,
      title: title,
    }),
  };

  const response = await fetch(`${base_url}/sendFeedback`, requestOptions);

  const data = await response.json();

  return data;
};

export const getHomeContent = async () => {
  let localData = localStorage.getItem("homePage");
  if (localData !== null && (await checkNewData(3))) {
    return;
  }

  const response = await fetch(
    `${base_url}/getHomePageContent`,
    requestOptionsGET
  );

  const data = await response.json();

  localStorage.setItem("homePage", JSON.stringify(data["data"]));
};

export const getAbout = async () => {
  let localData = localStorage.getItem("about");
  if (localData !== null && (await checkNewData(2))) {
    return;
  }

  const response = await fetch(`${base_url}/getAbout`, requestOptionsGET);

  const data = await response.json();
  localStorage.setItem("about", JSON.stringify(data));
};

export const getResearchersDetails = async () => {
  const response = await fetch(`${base_url}/getResearchers`, requestOptionsGET);
  const data = await response.json();

  return data;
};

export const getResources = async () => {
  const response = await fetch(`${base_url}/getResources`, requestOptionsGET);

  const data = await response.json();
  return data;
};
